import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from 'sonner';
import LoginPage from './pages/LoginPage';
import MemberDashboard from './pages/MemberDashboard';
import AdminPanel from './pages/AdminPanel';

function Splash() {
  return (
    <div className="min-h-screen flex items-center justify-center islamic-pattern">
      <div className="w-10 h-10 rounded-full border-2 border-[#d9a94e] border-t-transparent animate-spin" />
    </div>
  );
}

function MemberRoute({ children }) {
  const { user, bootLoading } = useAuth();
  if (bootLoading) return <Splash />;
  if (!user) return <Navigate to="/" replace />;
  if (user.role === 'admin') return <Navigate to="/admin" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, bootLoading } = useAuth();
  if (bootLoading) return <Splash />;
  if (!user || user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { user, bootLoading } = useAuth();
  if (bootLoading) return <Splash />;
  if (user?.role === 'admin') return <Navigate to="/admin" replace />;
  if (user?.role === 'member') return <Navigate to="/dashboard" replace />;
  return <LoginPage />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route
              path="/dashboard"
              element={
                <MemberRoute>
                  <MemberDashboard />
                </MemberRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AdminPanel />
                </AdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
